import {store} from '../../store';
import {QUERY_FIELDS_ALL, QUERY_FIELDS_SEPARATOR, URL_FIELDS_PARAM} from '../const';
import type {DefaultRootState} from 'react-redux';

function getAllQueryFieldsLength(): number {
    const state = store.getState() as DefaultRootState;
    const containerName = state.settings.containerName;
    const allQueryFields = state.settings.containers[containerName]?.queryFields ?? [];
    return allQueryFields.length;
}

export function encodeQueryFields(showFieldSpecificSearchEnabled: boolean, queryFields: string[]): string {
    const allQueryFieldsLength = getAllQueryFieldsLength();
    const encodedQueryFields = allQueryFieldsLength > 0 && allQueryFieldsLength === queryFields.length
        ? QUERY_FIELDS_ALL : queryFields.filter(queryField => queryField !== '').join(QUERY_FIELDS_SEPARATOR);
    const state = store.getState() as DefaultRootState;
    if (showFieldSpecificSearchEnabled && state.settings.fieldSpecificSearch) {
        return `${URL_FIELDS_PARAM}=${encodedQueryFields}`;
    } else {
        return ''; // do not show parameter in URL, if user disabled field specific search
    }

}
